import { ROUTES } from "Constants/AllRoutes";

export const PageLinks = [
  {
    key: "1",
    label: "Home",
    target: ROUTES.HOME,
  },
  {
    key: "2",
    label: "Our Team",
    target: ROUTES.OUR_TEAM,
  },
  {
    key: "3",
    label: "Blog",
    target: ROUTES.BLOG,
  },
];
